import { createTheme, Theme } from '@mui/material';
import { indigo } from '@mui/material/colors';

export const lightTheme: Theme = createTheme({
  palette: {
    mode: 'light',
    primary: indigo,
    secondary: {
      main: '#283593',
    },
    background: {
      default: '#FCFCFC',
      paper: '#FCFCFC',
    },
  },
});

export const darkTheme: Theme = createTheme({
  palette: {
    mode: 'dark',
  },
});

export const dreherLightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#607d8b' },
    secondary: { main: '#455a64' },
  },
});

export const dreherDarkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#607d8b' },
    secondary: { main: '#cfd8dc' },
  },
});

// Material UI Theme is not serializable, separate function instead of selector
export const getTheme = (vendor: string, isDarkMode: boolean): Theme => {
  switch (vendor) {
    case 'dreher': {
      return isDarkMode ? dreherDarkTheme : dreherLightTheme;
    }
    default: {
      return isDarkMode ? darkTheme : lightTheme;
    }
  }
};
